import './ProblemStatement.css';
import { useScrollReveal } from '../../../useScrollReveal';

const ProblemStatement = (props) => {
    const { ref, style } = useScrollReveal();

    return (
        <div className={`ProblemStatement ${props.smallTitle ? 'small' : ''}`} ref={ref} style={style}>
            <h2>
                {props.title}
            </h2>
            <div className="description" dangerouslySetInnerHTML={{ __html: props.description }}/>
        </div>
    );
};

export default ProblemStatement;
